import styled from "styled-components";
import { Container, Store, Wrapper, Atom } from 'AppReact';
import { OccupantSection } from './occupant';
import { AddSection } from '../../../common/molecules';
import device from "utils/device";
import { switchLabel } from '../../../utilities';

const template = styled.div`
    width: 336px;
    padding: 0 24px;
    margin: 0 auto;

    @media ${device.tablet} {
        width: 594px;
    }
`

export const definition = {
    name: "Occupants",
    props: { occupants: Store, selectedTabId: Store, language: Store, photoIDs: Store },
    elements: [
        {
            wrapper: Wrapper(template),
            name: "Wrapper",
            elements: [
                {
                    componentSelect: switchLabel,
                    name: 'SectionTitle',
                    displayValue: ({ language }) => ` ${ language?.occupants || 'Occupants'}`,
                    bindings: ({ selectedTabId }) => selectedTabId
                },
                {
                    component: OccupantSection,
                    isListOf: 'occupants',
                    name: 'OccupantList',
                    bindings: ({ occupants, occupant, occupantIndex, selectedTabId, language }) => {
                        return ({ language, occupants, occupant, occupantIndex, onReview: selectedTabId == 'review' })
                    }
                },
                {
                    component: AddSection,
                    name: 'AddOccupant',
                    isButton: true,
                    renderIf: ({ selectedTabId }) => selectedTabId !== 'review',
                    bindings: ({ occupants }) => ({ occupants, label: "Add Occupant" }),
                },
            ]
        },
    ],
}

const Occupants = Container(definition)

export default Occupants;
